import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatDetail } from "@/lib/api";
import { Loader2, RefreshCw, Clock, MapPin } from "lucide-react";

export function ReservationsAdmin() {
  const [rows, setRows] = useState(null);
  const load = async () => {
    try { const { data } = await api.get("/admin/reservations"); setRows(data.reservations || []); }
    catch (e) { toast.error(formatDetail(e.response?.data?.detail) || e.message); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="mv-card p-5" data-testid="admin-reservations">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Clock size={16} className="mv-green-text"/>
          <div className="font-display text-[16px] mv-green-text">Reservations (14-day plot locks)</div>
        </div>
        <button type="button" onClick={load} className="btn-ghost !py-1.5"><RefreshCw size={14}/> Refresh</button>
      </div>
      {rows === null ? (
        <div className="text-[13px] flex items-center gap-2" style={{ color: "var(--mv-muted)" }}>
          <Loader2 size={13} className="animate-spin"/> Loading…
        </div>
      ) : rows.length === 0 ? (
        <div className="text-[13px]" style={{ color: "var(--mv-muted)" }}>No reservations yet.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-[13px]">
            <thead>
              <tr className="text-left" style={{ color: "var(--mv-muted)" }}>
                <th className="py-2 pr-4">Created</th>
                <th className="py-2 pr-4">Project</th>
                <th className="py-2 pr-4">Investor</th>
                <th className="py-2 pr-4">Contact</th>
                <th className="py-2 pr-4">Plot pref</th>
                <th className="py-2 pr-4">Expires</th>
                <th className="py-2">Ref</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t mv-hairline align-top" data-testid={`admin-reservation-${r.id}`}>
                  <td className="py-2 pr-4 whitespace-nowrap">{new Date(r.created_at).toLocaleString()}</td>
                  <td className="py-2 pr-4 font-semibold mv-green-text">{r.project_name}</td>
                  <td className="py-2 pr-4">{r.full_name}</td>
                  <td className="py-2 pr-4">
                    <div>{r.email}</div>
                    <div className="text-[11.5px]" style={{ color: "var(--mv-muted)" }}>{r.phone}</div>
                  </td>
                  <td className="py-2 pr-4">{r.plot_pref || "—"}</td>
                  <td className="py-2 pr-4 whitespace-nowrap">{new Date(r.expires_at).toLocaleDateString()}</td>
                  <td className="py-2 font-mono text-[11.5px]">{r.ref_code || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export function SiteVisitsAdmin() {
  const [rows, setRows] = useState(null);
  const load = async () => {
    try { const { data } = await api.get("/admin/site-visits"); setRows(data.site_visits || []); }
    catch (e) { toast.error(formatDetail(e.response?.data?.detail) || e.message); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="mv-card p-5" data-testid="admin-site-visits">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <MapPin size={16} className="mv-green-text"/>
          <div className="font-display text-[16px] mv-green-text">Site-visit requests</div>
        </div>
        <button type="button" onClick={load} className="btn-ghost !py-1.5"><RefreshCw size={14}/> Refresh</button>
      </div>
      {rows === null ? (
        <div className="text-[13px] flex items-center gap-2" style={{ color: "var(--mv-muted)" }}>
          <Loader2 size={13} className="animate-spin"/> Loading…
        </div>
      ) : rows.length === 0 ? (
        <div className="text-[13px]" style={{ color: "var(--mv-muted)" }}>No site-visit requests yet.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-[13px]">
            <thead>
              <tr className="text-left" style={{ color: "var(--mv-muted)" }}>
                <th className="py-2 pr-4">Created</th>
                <th className="py-2 pr-4">Project</th>
                <th className="py-2 pr-4">Investor</th>
                <th className="py-2 pr-4">Party</th>
                <th className="py-2 pr-4">Preferred</th>
                <th className="py-2">Contact</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t mv-hairline align-top" data-testid={`admin-site-visit-${r.id}`}>
                  <td className="py-2 pr-4 whitespace-nowrap">{new Date(r.created_at).toLocaleString()}</td>
                  <td className="py-2 pr-4 font-semibold mv-green-text">{r.project_name}</td>
                  <td className="py-2 pr-4">{r.full_name}</td>
                  <td className="py-2 pr-4">{r.party_size}</td>
                  <td className="py-2 pr-4">{r.preferred || "—"}</td>
                  <td className="py-2">
                    <div>{r.email}</div>
                    <div className="text-[11.5px]" style={{ color: "var(--mv-muted)" }}>{r.phone}</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
